/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './user-panel-item.reducer';

export const UserPanelItemDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const userPanelItemEntity = useAppSelector(state => state.userPanelItem.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="userPanelItemDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.userPanelItem.detail.title">UserPanelItem</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.userPanelItem.id">Id</Translate>
            </span>
          </dt>
          <dd>{userPanelItemEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.userPanelItem.active">Active</Translate>
            </span>
          </dt>
          <dd>{userPanelItemEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.userPanelItem.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{userPanelItemEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.userPanelItem.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{userPanelItemEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.userPanelItem.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{userPanelItemEntity.timestampentry}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.userPanelItem.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{userPanelItemEntity.cursor}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.userPanelItem.item">Item</Translate>
          </dt>
          <dd>{userPanelItemEntity.item ? userPanelItemEntity.item.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.userPanelItem.panel">Panel</Translate>
          </dt>
          <dd>{userPanelItemEntity.panel ? userPanelItemEntity.panel.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/user-panel-item" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/user-panel-item/${userPanelItemEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default UserPanelItemDetail;
